// src/App.jsx
import React, { useState, useEffect } from 'react';
import { Container, ProgressBar } from 'react-bootstrap';
import { LanguageProvider } from './contexts/LanguageContext';
import { initGA, trackPageView, trackScroll } from './utils/analytics';

import Hero from './components/Hero';
import AboutMe from './components/AboutMe';
import PillarsSection from './components/PillarsSection';
import Presentation from './components/Presentation';
import AboutChat from './components/AboutChat';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LanguageSwitch from './components/LanguageSwitch';
import SEO from './components/SEO';

export default function App() {
  const [progress, setProgress] = useState(0);
  const [scrollMilestones, setScrollMilestones] = useState({
    25: false,
    50: false,
    75: false,
    100: false,
  });

  // Inicializar Google Analytics e rastrear pageview inicial
  useEffect(() => {
    // Garantir que a página sempre comece no topo ao carregar
    window.scrollTo(0, 0);

    // Inicializar Google Analytics
    initGA();

    // Rastrear visualização da página inicial
    trackPageView(window.location.pathname + window.location.search, document.title);

    // Se houver hash na URL, remover após um pequeno delay para evitar scroll automático
    if (window.location.hash) {
      setTimeout(() => {
        window.history.replaceState(null, '', window.location.pathname);
      }, 100);
    }
  }, []);

  // Rastrear scroll e marcos de engajamento
  useEffect(() => {
    function onScroll() {
      const scrollTop = window.pageYOffset;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPercentage = (scrollTop / docHeight) * 100;
      setProgress(scrollPercentage);

      // Rastrear marcos de scroll (25%, 50%, 75%, 100%)
      const milestones = [25, 50, 75, 100];
      milestones.forEach((milestone) => {
        if (scrollPercentage >= milestone && !scrollMilestones[milestone]) {
          trackScroll(milestone);
          setScrollMilestones((prev) => ({ ...prev, [milestone]: true }));
        }
      });
    }
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollMilestones]);

  return (
    <LanguageProvider>
      <SEO />
      {/* Top HUD-style progress bar 
      <ProgressBar
        now={progress}
        animated
        className="position-fixed w-100 top-0"
        style={{ height: '6px' }}
        variant="info"
      />*/}

      <LanguageSwitch />

      <Container>
        {/* Hero section */}
        <Hero />

        {/* Chat interativo Pergunte sobre mim */}
        <AboutChat />

        {/* 1. Apresentação Pessoal */}
        <AboutMe />

        {/* 2. Identificação com os Pilares 
        <PillarsSection />*/}

        {/* Roteiro de 3 minutos 
        <Presentation />*/}

        {/* Chat interativo Pergunte sobre mim 
        <AboutChat />*/}

        {/* Seção de Contato */}
        <Contact />

        {/* Rodapé */}
        <Footer />
      </Container>
    </LanguageProvider>
  );
}
